// extracted by mini-css-extract-plugin
module.exports = {"container":"SHqfsv_2GS","logo-container":"_8ZfFihtUo-","logoContainer":"_8ZfFihtUo-","logo":"_7T8u3XAzqF","brand-logo":"_2Zvn0cjMoO","brandLogo":"_2Zvn0cjMoO","brand-logo-container":"_2gn--A8Qey","brandLogoContainer":"_2gn--A8Qey","vertical":"_2wQyrbJB6d","custom-branding":"_4Z1FHuMULn","customBranding":"_4Z1FHuMULn"};
    if(module.hot) {
      // 1614934709682
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  